/**
 * Plugin client-side per sincronizzare lo stato di impersonazione
 * Gestisce l'hydration e la sincronizzazione tra localStorage e stato reattivo
 */
export default defineNuxtPlugin(() => {
  // Inizializza il composable di impersonazione
  const { initializeState } = useImpersonation()

  // Inizializza lo stato quando il plugin viene caricato
  if (import.meta.client) {
    // Inizializza immediatamente - non è più necessario aspettare onMounted
    // poiché ora usiamo l'inizializzazione lazy nei computed
    initializeState()
  }
})
